import * as React from "react";

export function useIsOffline() {
	const [isOffLine, setIsOffLine] = React.useState(false);

	React.useEffect(() => {
		const onOffline = () => {
			setIsOffLine(!navigator.onLine);
		};
		window.addEventListener("offline", onOffline);
		window.addEventListener("online", onOffline);

		return () => {
			window.removeEventListener("offline", onOffline);
			window.removeEventListener("online", onOffline);
		};
	}, []);

	return isOffLine;
}
